/** Delivery moments: the days and time windows a shopper picks from on the checkout. */
export default {
    settings: {
        title: 'Delivery moments',
        intro: 'The days and time windows a shopper picks from on the checkout. Pickup orders are not asked for one.',
        saved: 'Delivery moments saved',
        weekdays: {
            mon: 'Monday',
            tue: 'Tuesday',
            wed: 'Wednesday',
            thu: 'Thursday',
            fri: 'Friday',
            sat: 'Saturday',
            sun: 'Sunday',
        },
        schedule: {
            title: 'Weekly schedule',
            intro: 'The time windows a shopper can choose on each day of the week. A day without windows has no delivery.',
            noDelivery: 'No delivery',
            noWindows: 'There are no windows yet, so shoppers have no delivery moment to choose.',
            from: 'From',
            until: 'Until',
            addWindow: 'Add window',
            removeWindow: 'Remove window',
        },
        rules: {
            title: 'Ordering rules',
            cutoff: 'Order before',
            leadDays: 'Lead time (days)',
            leadDaysHint: 'From an order before the cut-off to the first delivery day. 0 delivers the same day.',
            horizonDays: 'Bookable ahead (days)',
            horizonDaysHint: 'How many days ahead a shopper can book, 1 to 90.',
            cutoffHelp: {
                sameDay: 'Orders placed before {time} are delivered from the same day; after {time} from the next day.',
                nextDay: 'Orders placed before {time} are delivered from tomorrow; after {time} from the day after.',
                later: 'Orders placed before {time} are delivered from {days} days later; after {time} from {next} days later.',
            },
        },
        closed: {
            title: 'Closed dates',
            intro: 'Extra days without delivery, such as public holidays. The {link} is already left out, so it does not need adding here.',
            closureLink: 'holiday closure',
            date: 'Date',
            add: 'Add date',
            remove: 'Remove {date}',
            none: 'No closed dates.',
        },
    },
};
